<template>
  <div class="page-wrap">
    <div class="page-container">
      <!-- 上传配置卡片 -->
      <!-- <div class="search-card">
        <el-form :label-position="'right'" label-width="120px">
          <el-form-item label="后端地址:">
            <el-input v-model="config.baseUrl" placeholder="http://localhost:8081" size="mini" style="width:260px" />
          </el-form-item>
          <el-form-item label="鉴权Token:">
            <el-input v-model="config.token" placeholder="authorize 请求头" size="mini" style="width:260px" />
          </el-form-item>
          <el-form-item label="上传目录:">
            <el-input v-model="config.dir" placeholder="drama/test" size="mini" style="width:260px" />
          </el-form-item>
          <el-form-item label="文件夹ID:">
            <el-input v-model="config.folderId" placeholder="预留扩展，可留空" size="mini" style="width:260px" />
          </el-form-item>
          <el-form-item label="分片阈值:">
            <el-input-number v-model="config.thresholdMb" :min="1" :max="500" size="mini" />
            <span style="margin-left:8px;color:#86909c;font-size:12px">MB，超过则走分片上传</span>
          </el-form-item>
          <el-form-item label="分片大小:">
            <el-input-number v-model="config.partSizeMb" :min="5" :max="100" size="mini" />
            <span style="margin-left:8px;color:#86909c;font-size:12px">MB，默认 5MB</span>
          </el-form-item>
          <el-form-item label="并发数量:">
            <el-input-number v-model="config.concurrency" :min="1" :max="10" size="mini" />
            <span style="margin-left:8px;color:#86909c;font-size:12px">分片并发数，默认 3</span>
          </el-form-item>
        </el-form>
      </div> -->

      <!-- 拖拽上传区域 -->
      <div class="search-card">
        <div class="drop-area" :class="{ 'dragover': isDragOver }" @click="handleSelectFile"
          @dragover.prevent="isDragOver = true" @dragleave.prevent="isDragOver = false" @drop.prevent="handleDrop">
          <el-icon size="40" color="#3370ff" style="margin-bottom:12px">
            <UploadFilled />
          </el-icon>
          <div class="drop-text">点击选择文件，或拖拽文件到此处上传</div>
          <div class="drop-tip">支持多文件批量上传，大文件自动分片，视频自动生成封面</div>
        </div>
        <input ref="fileInputRef" type="file" multiple style="display:none" @change="handleFileChange" />
      </div>

      <!-- 文件列表 -->
      <div class="search-card" v-if="fileList.length > 0">
        <!-- 上传中提示条 -->
        <div class="upload-warning-tip" v-if="hasUploadingFile">
          <el-icon size="16" style="margin-right:6px;vertical-align:-2px">
            <Warning />
          </el-icon>
          正在上传文件，请勿关闭或刷新页面，以免造成上传失败
        </div>

        <div class="upload-summary">
          <span>共 {{ uploadSummary.total }} 个</span>
          <span class="summary-item success">已完成 {{ uploadSummary.success }}</span>
          <span class="summary-item uploading">上传中 {{ uploadSummary.uploading }}</span>
          <span class="summary-item waiting">等待中 {{ uploadSummary.waiting }}</span>
          <span class="summary-item fail">失败 {{ uploadSummary.fail }}</span>
        </div>
        <div class="list-header">
          <span class="list-title">上传列表</span>
          <div class="list-actions">
            <el-button size="mini" @click="handleClearAll">清空列表</el-button>
            <el-button type="success" size="mini" @click="handleStartAll">全部开始上传</el-button>
          </div>
        </div>
        <div class="file-list">
          <div class="file-item" v-for="item in fileList" :key="item.id">
            <div class="file-info">
              <div class="file-name">{{ item.fileName }}</div>
              <div class="file-meta">
                <span>{{ formatSize(item.fileSize) }}</span>
                <span class="file-type">{{ item.isMultipart ? '分片上传' : '普通直传' }}</span>
                <span :class="['status-tag', 'status-' + item.status]">
                  {{ statusText[item.status] }}
                </span>
              </div>
            </div>
            <div class="file-progress">
              <el-progress :percentage="item.progress" :status="item.status === 'fail' ? 'exception' : ''"
                :stroke-width="8" :show-text="false" />
              <span class="progress-text">{{ item.progress }}%</span>
            </div>
            <div class="file-actions">
              <el-button v-if="item.status === 'pending' || item.status === 'fail'" type="primary" size="mini"
                @click="handleUploadItem(item)">
                {{ item.status === 'fail' ? '重试' : '上传' }}
              </el-button>
              <el-button v-if="item.status === 'uploading' || item.status === 'waiting'" type="warning" size="mini" @click="handleAbortItem(item)">
                取消
              </el-button>
              <!-- <el-button v-if="item.status === 'success'" type="success" size="mini" @click="handleCopyUrl(item)">
                复制链接
              </el-button> -->
              <el-button size="mini" @click="handleRemoveItem(item)">删除</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed, watch } from 'vue'
import { ElMessage } from 'element-plus'
import SparkMD5 from 'spark-md5'
import { baseURL } from '@/request/config'

export default {
  // yly上传素材
  name: 'ylySucaiUpload',
  components: {},
  props: ['upData'],
  setup(props) {
    const fileInputRef = ref(null)
    const isDragOver = ref(false)

    const statusText = {
      pending: '待上传',
      waiting: '排队等待',
      computing: '计算MD5',
      uploading: '上传中',
      success: '上传成功',
      fail: '上传失败',
      aborted: '已取消'
    }

    const MAX_CONCURRENT_UPLOADS = 3

    const state = reactive({
      config: {
        baseUrl: baseURL,
        token: 'Bearer' + localStorage.getItem('token'),
        //文件夹地址
        dir: 'drama/test',
        folderId: '',
        thresholdMb: 50,
        partSizeMb: 5,
        concurrency: 3,
        upData: props.upData,
      },
      fileList: [],
      abortControllers: {},
      uploadQueue: []

    })

    // 是否有正在上传的文件
    const hasUploadingFile = computed(() => {
      return state.fileList.some(item => item.status === 'uploading' || item.status === 'computing')
    })

    const uploadSummary = computed(() => {
      const list = state.fileList
      const count = (arr) => list.filter(i => arr.includes(i.status)).length
      return {
        total: list.length,
        success: count(['success']),
        uploading: count(['uploading', 'computing']),
        waiting: count(['waiting']),
        fail: count(['fail']),
        pending: count(['pending']),
        aborted: count(['aborted'])
      }
    })

    watch(() => props.upData, (val) => {
      state.config.upData = val
    }, { immediate: true, deep: true })

    const getFolderId = () => {
      if (state.config.upData?.type === 'sucaiListPage') {
        return state.config.upData.data?.folderId || null
      }
      return state.config.folderId || null
    }

    // ========== 工具函数 ==========
    const formatSize = (bytes) => {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      if (bytes < 1024 * 1024 * 1024) return (bytes / 1024 / 1024).toFixed(1) + ' MB'
      return (bytes / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    }

    const getContentType = (fileName) => {
      const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const map = {
        '.jpg': 'image/jpeg', '.jpeg': 'image/jpeg', '.png': 'image/png', '.gif': 'image/gif',
        '.bmp': 'image/bmp', '.webp': 'image/webp', '.mp4': 'video/mp4', '.m4v': 'video/mp4',
        '.mov': 'video/quicktime', '.avi': 'video/x-msvideo', '.mkv': 'video/x-matroska',
        '.webm': 'video/webm', '.mp3': 'audio/mpeg', '.wav': 'audio/wav',
        '.pdf': 'application/pdf', '.doc': 'application/msword',
        '.docx': 'application/vnd.ms-word', '.xls': 'application/vnd.ms-excel',
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.txt': 'text/plain', '.zip': 'application/zip'
      }
      return map[ext] || 'application/octet-stream'
    }

    const isVideoFile = (fileName) => getContentType(fileName).startsWith('video/')

    const generateId = () => Date.now() + '_' + Math.random().toString(36).slice(2, 8)

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

    const getHeaders = () => {
      const headers = { 'Content-Type': 'application/json' }
      if (state.config.token) headers['authorize'] = state.config.token
      return headers
    }

    // ========== MD5 分块计算 ==========
    const computeMd5 = (file) => {
      return new Promise((resolve, reject) => {
        const spark = new SparkMD5.ArrayBuffer()
        const chunkSize = 4 * 1024 * 1024 // 4MB 分块读取，避免大文件卡顿
        let offset = 0
        const reader = new FileReader()

        reader.onerror = () => reject(new Error('读取文件计算MD5失败'))
        reader.onload = e => {
          spark.append(e.target.result)
          offset += chunkSize
          if (offset < file.size) {
            readNext()
          } else {
            resolve(spark.end())
          }
        }

        function readNext() {
          const slice = file.slice(offset, Math.min(offset + chunkSize, file.size))
          reader.readAsArrayBuffer(slice)
        }
        readNext()
      })
    }

    // ========== 视频封面截帧 ==========
    const generateCoverBlob = (file) => {
      const url = URL.createObjectURL(file)
      return new Promise((resolve) => {
        const video = document.createElement('video')
        video.muted = true
        video.playsInline = true
        video.preload = 'auto'
        video.src = url
        video.onloadeddata = () => {
          try {
            const time = Math.min(1, Math.max(0.1, video.duration * 0.1 || 0.1))
            video.currentTime = time
          } catch (e) { }
        }
        video.onseeked = () => {
          try {
            const canvas = document.createElement('canvas')
            const scale = Math.min(1, 320 / video.videoWidth)
            canvas.width = Math.round(video.videoWidth * scale) || 320
            canvas.height = Math.round(video.videoHeight * scale) || 180
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
            canvas.toBlob(blob => {
              URL.revokeObjectURL(url)
              resolve(blob || null)
            }, 'image/jpeg', 0.8)
          } catch (e) {
            URL.revokeObjectURL(url)
            resolve(null)
          }
        }
        video.onerror = () => {
          URL.revokeObjectURL(url)
          resolve(null)
        }
      })
    }

    // ========== 文件选择与拖拽 ==========
    const handleSelectFile = () => {
      fileInputRef.value.click()
    }

    const handleFileChange = (e) => {
      const files = Array.from(e.target.files)
      addFiles(files)
      e.target.value = ''
    }

    const handleDrop = (e) => {
      isDragOver.value = false
      const files = Array.from(e.dataTransfer.files)
      addFiles(files)
    }

    const addFiles = (files) => {
      files.forEach(file => {
        const id = generateId()
        const contentType = getContentType(file.name)
        const isMultipart = file.size > state.config.thresholdMb * 1024 * 1024
        state.fileList.push({
          id,
          rawFile: file,
          fileName: file.name,
          fileSize: file.size,
          contentType,
          isMultipart,
          status: 'pending',
          progress: 0,
          errorMsg: '',
          fileKey: '',
          uploadId: '',
          url: '',
          coverUrl: '',
          coverBlob: null,
          md5: ''
        })
      })
    }

    // ========== 上传核心逻辑（文件级并发队列，最多3个同时上传） ==========
    const handleUploadItem = (item) => {
      if (item.status === 'uploading' || item.status === 'computing' || item.status === 'waiting') return
      if (!state.uploadQueue.includes(item.id)) state.uploadQueue.push(item.id)
      if (item.status === 'pending' || item.status === 'fail' || item.status === 'aborted') {
        item.status = 'waiting'
      }
      pumpQueue()
    }

    const pumpQueue = () => {
      const active = state.fileList.filter(i => i.status === 'uploading' || i.status === 'computing').length
      const slots = MAX_CONCURRENT_UPLOADS - active
      for (let i = 0; i < slots; i++) {
        const nextId = state.uploadQueue.shift()
        if (!nextId) return
        const next = state.fileList.find(f => f.id === nextId)
        if (!next || next.status === 'success') continue
        runUploadItem(next)
      }
    }

    const runUploadItem = async (item) => {
      item.status = 'computing'
      item.progress = 0
      item.errorMsg = ''

      try {
        // 1. 先计算文件 MD5
        const md5 = await computeMd5(item.rawFile)
        item.md5 = md5
        item.progress = 5

        // 2. 视频预生成封面
        if (isVideoFile(item.fileName)) {
          item.coverBlob = await generateCoverBlob(item.rawFile)
        }

        item.status = 'uploading'

        // 3. 走对应上传流程
        if (item.isMultipart) {
          // 分片上传  全部走分片
          await uploadMultipart(item)
        } else {
          // 普通直传
          await uploadNormal(item)
        }

        item.status = 'success'
        item.progress = 100
        ElMessage.success(`${item.fileName} 上传成功`)
      } catch (e) {
        if (item.status === 'aborted') return
        item.status = 'fail'
        item.errorMsg = e.message
        ElMessage.error(`${item.fileName} 上传失败: ${e.message}`)
      } finally {
        pumpQueue()
      }
    }

    // 普通直传
    const uploadNormal = async (item) => {
      const { baseUrl, dir } = state.config
      const headers = getHeaders()
      const folderId = getFolderId()
      // 1. 获取预签名URL
      const presignRes = await fetch(`${baseUrl}/yly/sucai/presignUrl`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          files: [{
            fileName: item.fileName,
            contentType: item.contentType,
            dir,
            folderId: folderId || null,


          }]
        })
      })
      const presignJson = await presignRes.json()
      if (presignJson.code !== 200) throw new Error(presignJson.msg || '获取预签名失败')

      const presignData = presignJson.data[0]
      item.fileKey = presignData.fileKey
      item.progress = 10

      // 2. PUT直传文件本体
      await fetch(presignData.presignedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': presignData.contentType },
        body: item.rawFile
      })
      item.progress = 70

      // 3. 上传视频封面
      if (presignData.coverPresignedUrl && item.coverBlob) {
        await fetch(presignData.coverPresignedUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'image/jpeg' },
          body: item.coverBlob
        })
      }
      item.progress = 85

      // 4. 确认入库（携带 md5 和 folderId）
      const confirmRes = await fetch(`${baseUrl}/yly/sucai/confirmUpload`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          fileKey: presignData.fileKey,
          fileName: item.fileName,
          fileSize: item.fileSize,
          coverFileKey: presignData.coverFileKey,
          md5: item.md5,
          folderId: folderId || null
        })
      })
      const confirmJson = await confirmRes.json()
      if (confirmJson.code !== 200) throw new Error(confirmJson.msg || '确认入库失败')

      item.url = confirmJson.data.url
      item.coverUrl = confirmJson.data.coverUrl
      item.progress = 100
    }

    // 分片上传
    const uploadMultipart = async (item) => {
      const { baseUrl, concurrency, partSizeMb, dir } = state.config
      const headers = getHeaders()
      const partSize = partSizeMb * 1024 * 1024
      const folderId = getFolderId()

      // 1. 创建分片任务（携带 md5 和 folderId）
      const createRes = await fetch(`${baseUrl}/yly/sucai/createMultipartUpload`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          fileName: item.fileName,
          contentType: item.contentType,
          dir,
          fileSize: item.fileSize,
          partSize,
          md5: item.md5,
          folderId
        })
      })
      const createJson = await createRes.json()
      if (createJson.code !== 200) throw new Error(createJson.msg || '创建分片任务失败')

      const multipartData = createJson.data

      // 如果 reused 为 true，表示文件已存在，直接复用，无需分片上传和合并
      if (multipartData.reused) {
        item.fileKey = multipartData.fileKey
        item.url = multipartData.url
        item.coverUrl = multipartData.coverFileKey || ''
        item.progress = 100
        return
      }

      item.fileKey = multipartData.fileKey
      item.uploadId = multipartData.uploadId
      const parts = multipartData.parts
      const totalParts = parts.length
      let completedParts = 0
      item.progress = 10

      // 2. 并发上传分片
      const tasks = parts.map(part => async () => {
        for (let retry = 0; retry < 3; retry++) {
          try {
            const blob = item.rawFile.slice(
              (part.partNumber - 1) * multipartData.partSize,
              (part.partNumber - 1) * multipartData.partSize + part.size
            )
            const resp = await fetch(part.presignedUrl, {
              method: 'PUT',
              headers: { 'Content-Type': item.contentType },
              body: blob
            })
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
            completedParts++
            item.progress = Math.round(10 + (completedParts / totalParts) * 78)
            return part.partNumber
          } catch (e) {
            if (retry >= 2) throw e
            await sleep(500 * (retry + 1))
          }
        }
      })

      // 并发控制
      const queue = tasks.slice()
      const workers = Array.from({ length: Math.max(1, concurrency) }, async () => {
        while (queue.length > 0) {
          const task = queue.shift()
          if (task) await task()
        }
      })

      try {
        await Promise.all(workers)
      } catch (e) {
        // 失败则终止分片任务
        await fetch(`${baseUrl}/yly/sucai/abortMultipartUpload`, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            fileKey: multipartData.fileKey,
            uploadId: multipartData.uploadId
          })
        }).catch(() => { })
        throw new Error('分片上传失败，已清理临时文件')
      }

      item.progress = 88

      // 3. 上传视频封面
      if (multipartData.coverPresignedUrl && item.coverBlob) {
        await fetch(multipartData.coverPresignedUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'image/jpeg' },
          body: item.coverBlob
        })
      }
      item.progress = 92

      // 4. 完成合并入库（携带 md5 和 folderId）
      const completeRes = await fetch(`${baseUrl}/yly/sucai/completeMultipartUpload`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          fileKey: multipartData.fileKey,
          uploadId: multipartData.uploadId,
          fileName: item.fileName,
          fileSize: item.fileSize,
          coverFileKey: multipartData.coverFileKey,
          md5: item.md5,
          folderId: folderId || null
        })
      })
      const completeJson = await completeRes.json()
      if (completeJson.code !== 200) throw new Error(completeJson.msg || '合并分片失败')

      item.url = completeJson.data.url
      item.coverUrl = completeJson.data.coverUrl
      item.progress = 100
    }

    // ========== 操作函数 ==========
    const handleAbortItem = (item) => {
      const qi = state.uploadQueue.indexOf(item.id)
      if (qi > -1) state.uploadQueue.splice(qi, 1)
      item.status = 'aborted'
      ElMessage.info(`${item.fileName} 已取消上传`)
      pumpQueue()
    }

    const handleRemoveItem = (item) => {
      const qi = state.uploadQueue.indexOf(item.id)
      if (qi > -1) state.uploadQueue.splice(qi, 1)
      const index = state.fileList.findIndex(f => f.id === item.id)
      if (index > -1) state.fileList.splice(index, 1)
      pumpQueue()
    }

    const handleClearAll = () => {
      state.fileList = []
      state.uploadQueue = []
    }

    const handleStartAll = () => {
      state.fileList.forEach(item => {
        if (item.status === 'pending' || item.status === 'fail') {
          handleUploadItem(item)
        }
      })
    }

    const handleCopyUrl = (item) => {
      navigator.clipboard.writeText(item.url).then(() => {
        ElMessage.success('链接已复制到剪贴板')
      })
    }

    return {
      ...toRefs(state),
      fileInputRef,
      isDragOver,
      statusText,
      hasUploadingFile,
      uploadSummary,
      formatSize,
      handleSelectFile,
      handleFileChange,
      handleDrop,
      handleUploadItem,
      handleAbortItem,
      handleRemoveItem,
      handleClearAll,
      handleStartAll,
      handleCopyUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 上传中警告提示条
.upload-warning-tip {
  padding: 10px 16px;
  margin-bottom: 16px;
  border-radius: 10px;
  background: #fff7e6;
  border-left: 3px solid #fa8c16;
  font-size: 13px;
  color: #874800;
  line-height: 1.6;
}

// 拖拽区域
.drop-area {
  border: 2px dashed #dcdfe6;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover,
  &.dragover {
    border-color: #3370ff;
    color: #3370ff;
    background: #f7f9ff;
  }

  .drop-text {
    font-size: 15px;
    color: #1f2329;
    margin-bottom: 6px;
  }

  .drop-tip {
    font-size: 12px;
    color: #86909c;
  }
}

// 文件列表
.upload-summary {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 12px;
  font-size: 13px;
  color: #4e5969;

  .summary-item {
    &.success { color: #00b42a; }
    &.uploading { color: #3370ff; }
    &.waiting { color: #ff7d00; }
    &.fail { color: #f53f3f; }
  }
}
.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  .list-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2329;
  }
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.6);

  .file-info {
    flex: 1;
    min-width: 0;

    .file-name {
      font-size: 14px;
      color: #1f2329;
      margin-bottom: 4px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-meta {
      font-size: 12px;
      color: #86909c;
      display: flex;
      gap: 12px;
      align-items: center;

      .file-type {
        padding: 1px 6px;
        background: #e8f3ff;
        color: #3370ff;
        border-radius: 4px;
        font-size: 11px;
      }
    }
  }

  .file-progress {
    width: 200px;
    display: flex;
    align-items: center;
    gap: 10px;

    .progress-text {
      font-size: 12px;
      color: #4e5969;
      min-width: 40px;
      text-align: right;
    }
  }

  .file-actions {
    display: flex;
    gap: 8px;
  }
}

.status-tag {
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;

  &.status-pending {
    background: #f2f3f5;
    color: #86909c;
  }

  &.status-computing {
    background: #e8f3ff;
    color: #3370ff;
  }

  &.status-uploading {
    background: #e8f3ff;
    color: #3370ff;
  }

  &.status-success {
    background: #e8ffea;
    color: #00b42a;
  }

  &.status-fail {
    background: #ffece8;
    color: #f53f3f;
  }

  &.status-aborted {
    background: #fff7e6;
    color: #ff7d00;
  }

  &.status-waiting {
    background: #fff7e6;
    color: #ff7d00;
  }
}

// Element Plus 组件深度定制
:deep() {

  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: #b8c8e3;
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  .el-button {
    border-radius: 12px !important;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  .el-progress-bar__outer {
    border-radius: 4px;
  }
}
</style>
